<template>
	<v-timeline dense class="job-timeline">
		<v-timeline-item hide-dot class="title">Analysis</v-timeline-item>
		<v-timeline-item small v-if="stat.analysisRequestStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(created)}}</v-col>
				<v-col cols="3" class="event">Queued</v-col>
				<v-col cols="4" class="code"><strong><span v-html="timeDuration(created, stat.analysisRequestStartTime)" /> QUEUE WAIT</strong></v-col>
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.analysisRequestStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.analysisRequestStartTime)}}</v-col>
				<v-col cols="3" class="event">Job Start</v-col>
				<v-col cols="4" class="code"><strong><span v-html="timeDuration(stat.analysisRequestStartTime, stat.analysisRequestEndTime)" /> JOB TOTAL</strong></v-col>
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.ingestionStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.ingestionStartTime)}}</v-col>
				<v-col cols="3" class="event">Ingestion</v-col>
				<v-col cols="3" class="code" v-html="timeDuration(stat.ingestionStartTime, stat.ingestionEndTime)" />
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.downloadToProcessorStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.downloadToProcessorStartTime)}}</v-col>
				<v-col cols="3" class="event">Download To Processor</v-col>
				<v-col cols="3" class="code" v-html="timeDuration(stat.downloadToProcessorStartTime, stat.downloadToProcessorEndTime)" />
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.extractionStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.extractionStartTime)}}</v-col>
				<v-col cols="3" class="event">Extraction</v-col>
				<v-col cols="3" class="code" v-html="timeDuration(stat.extractionStartTime, stat.extractionEndTime)" />
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.conversionStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.conversionStartTime)}}</v-col>
				<v-col cols="3" class="event">Conversion</v-col>
				<v-col cols="3" class="code" v-html="timeDuration(stat.conversionStartTime, stat.conversionEndTime)" />
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.analysisStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.analysisStartTime)}}</v-col>
				<v-col cols="3" class="event">Analysis</v-col>
				<v-col cols="3" class="code" v-html="timeDuration(stat.analysisStartTime, stat.analysisEndTime)" />
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.analysisResultsUploadStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.analysisResultsUploadStartTime)}}</v-col>
				<v-col cols="3" class="event">Analysis Upload</v-col>
				<v-col cols="3" class="code" v-html="timeDuration(stat.analysisResultsUploadStartTime, stat.analysisResultsUploadEndTime)" />
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.analysisRequestEndTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.analysisRequestEndTime)}}</v-col>
				<v-col cols="3" class="event">Job End</v-col>
				<v-col cols="4" class="code"></v-col>
			</v-row>
		</v-timeline-item>
	</v-timeline>
</template>

<script>
export default {
	props: {
		stat: Object,
		created: String,
	},
	data() {
		return {};
	},
	methods: {
	},
};
</script>
